<template>
  <div class="addevent container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background">
            <div class="card-header row">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-irish-date">
                  Create An Event
                </h4>
              </div>
            </div>
          </div>
          <div class="createeventCard">
            <b-tabs class="evnetTypesTabs">
              <b-tab
                title="Small Groups"
                active
                title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-secondary"
              >
                <EventInfo
                  client_name="MID"
                  field_name="event"
                  event_type="small_group"
                  action="create"
                  :locations="locations"
                />
              </b-tab>
              <b-tab
                title="Large Interactive Events"
                title-link-class="btn btn-bumblebee btn-mid btn-tab btn-mid-secondary"
              >
                <EventInfo
                  client_name="MID"
                  field_name="event"
                  event_type="large_interactive"
                  action="create"
                  :locations="locations"
                />
              </b-tab>
              <b-tab
                title="Large Host-centered Events"
                title-link-class="btn  btn-bumblebee btn-mid btn-tab btn-mid-secondary"
              >
                <EventInfo
                  client_name="MID"
                  field_name="event"
                  event_type="large_host_centered"
                  action="create"
                  :locations="locations"
              /></b-tab>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventInfo from "@/components/events/EventInfo.vue";

export default {
  name: "AddEvent",
  components: { EventInfo },
  data() {
    return {
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "New location", id: "on_site" },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/my_irish_date/events/AddEvent.vue